import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IGendersEnum, IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IGendersEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.genders");

export const genders = {
  ...getAllApis,
};
